import { useSelector } from 'react-redux';

import { DetailedIconEmail } from '@zillow/constellation';
import { Anchor, Text } from '@zillow/constellation-10';

import emailUtils from '../../../../utils/emailUtils';
import { PropertiesSelectors, UserSelectors } from '../../../../selectors';

const ConfirmationHasError = () => {
  const { isMultifamilyCustomer, isSingleFamilyEnterpriseCustomer } = useSelector((state) =>
    UserSelectors.makeUser(state),
  );
  const { isMultifamily } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));
  const email = emailUtils.getHelpEmail(isMultifamily && isMultifamilyCustomer, isSingleFamilyEnterpriseCustomer);

  return (
    <>
      <DetailedIconEmail />
      <Text textStyle="heading-sm" asChild css={{ marginBlock: '400' }}>
        <p>Contact a Zillow representative</p>
      </Text>
      <Text asChild>
        <p>
          Please email&nbsp;
          <Anchor href={`mailto:${email}`}>{email}</Anchor>
          &nbsp;for help with questions about your listing.
        </p>
      </Text>
    </>
  );
};

export default ConfirmationHasError;
